import { render, staticRenderFns } from "./ServiceObjectInfo.vue?vue&type=template&id=efabae14"
import script from "./ServiceObjectInfo.vue?vue&type=script&lang=ts"
export * from "./ServiceObjectInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports